<template>
<div class="client-select gen-form-container">
<!--  <h2>{{ stores.auth.currentClient?.title || "Svi klijenti" }}</h2>-->
  <FormSelect :options="clientList" v-model="currentClientId" />
</div>
</template>

<script>
import api from '@/Util/api';

export default {
  data: ()=>({
    clients: [],
  }),
  computed: {
    clientList() {
      var list=[
        {value: "", text: "Svi klijenti"},
        ...this.clients.map(client=>({
          value: client.uuid,
          text: client.title,
        })),
      ];
      return list;
    },
    currentClientId: {
      get() {
        return this.stores.auth.currentClient?.uuid || "";
      },
      set(value) {
        this.stores.auth.currentClient=this.clients.find(client=>client.uuid==value) || null;
        localStorage.setItem("bezbednoClient", value);
      },
    },
  },
  methods: {
    async loadClients() {
      this.clients=await api.list("Klijent");
      this.autoSelectClient();
    },
    autoSelectClient() {
      var currentClient=localStorage.getItem("bezbednoClient", "");
      this.currentClientId=currentClient;
    },
  },
  created() {
    this.loadClients(); // TODO refresh
  },
}
</script>
